import { environment } from '../environments/environment';
import { wizards } from './app-constants';

const baseUrl = environment.SERVER_API_URL + '/api';
const adminUrl = baseUrl + '/admin';
const assignmentUrl = '/assignment';
const createdByUrl = '/createdby';
const statusUrl = '/status';
const typeUrl = '/types';
const eventWizard = 'EVENT';
const VPS = 'VPS';
// const promotionsWizard: 'PROMOS';
// const virtualProShopWizard: 'VPS';
export const loginUrl = baseUrl + '/authenticate';
export const forgotPasswordUrl = baseUrl + '/account/reset-password/init';
export const resetPasswordUrl = baseUrl + '/account/reset-password/finish';
export const accountUrl = baseUrl + '/account';
export const changePasswordUrl = baseUrl + '/account/change-password';
export const imageUploadUrl = baseUrl + '/account/upload-image';
export const getImagesUrl = baseUrl + '/getimages';
export const getFooterUrl = baseUrl + '/footer';
export const getCurrencyUrl = baseUrl + '/profile/currency';
export const getLanguagesUrl = baseUrl + '/multidropdown/LANGUAGE';
export const getSalesSummaryUrl = baseUrl + '/sales/summary';
export const saveUserProfileUrl = baseUrl + '/account';
export const setDefaultViewUrl = baseUrl + '/admin/user-setting';
export const getCountryStateUrl = baseUrl + '/profile/country-state';
export const getBannerAndBrandImageUrl = baseUrl + '/login/images';
export const getContextList = baseUrl + '/getContextList';
export const getFeaturedProductUrl = adminUrl + '/featuredProducts';
export const getStyleListUrl = adminUrl + '/featuredProducts/style';
export const getBrandsTypesUrl = baseUrl + '/getBrands';
export const getSeasonListUrl = baseUrl + '/seasonList';
export const saveFeaturedProductUrl = adminUrl + '/featuredProducts/save';
export const getMultidropdown = baseUrl + '/getMultidropdown';
export const getMultidropdownSolr = baseUrl + '/multidropdown/solr';
export const getRegionListUrl = baseUrl + '/getSalesOrgList';
export const getCustomerListUrl = baseUrl + '/getCustomerList';
export const getSelectedCustomerListUrl = (catalogId: string) =>
  `${adminUrl}/collection/${catalogId}/customers`;
export const collectionUrl = adminUrl + '/collection';
export const collectionDeleteUrl = adminUrl + '/collection/delete';
export const copyCollectionUrl = collectionUrl + '/copy';
export const getCollectionCatalogTypesUrl = collectionUrl + typeUrl;
export const getCollectionStatusListUrl = collectionUrl + statusUrl;
export const getCatalogSearchCriteriaUrl = collectionUrl + '/searchCriteria';
export const preViewCollectionsUrl = collectionUrl + '/preview/v2';
export const collectionAssignmentUrl = collectionUrl + assignmentUrl;
export const downloadPdfUrl = baseUrl + '/downloadPdf/v2';
export const getDonwloadExcelCartUrl = baseUrl + '/cart/download/orderform/v2';
export const downloadImagesUrl = baseUrl + '/product/download/images/v2';
export const downloadUPCUrl = baseUrl + '/product/download/upc/v2';
export const exportOrderFormUrl = baseUrl + '/product/download/orderform/v2';
export const searchCollectionListUrl = adminUrl + '/collections/list';
export const getDropdownSalesOrgListUrl =
  baseUrl + '/multidropdowndb/SALES_ORG';
export const getDropdownSeasonListUrl = baseUrl + '/multidropdowndb/Season';
export const getDropdownCollectionListUrl =
  baseUrl + '/multidropdowndb/Collection';
export const manageSeasonUrl = adminUrl + '/season';
export const getDropdownCreatedByListUrl = adminUrl + '/season/createdby';
export const getDropdownStatusListUrl = adminUrl + '/season/status';
export const destinationsUrl = adminUrl + '/destination';
export const destinationStatusListUrl = adminUrl + '/destination/status';
export const destinationKeyCheckUrl = adminUrl + '/destination/validateKey';
export const webserviceUrl = adminUrl + '/webservice';
export const webserviceStatusUrl = webserviceUrl + statusUrl;
export const webserviceDestinationUrl = webserviceUrl + '/destination';
export const webserviceTestUrl = webserviceUrl + '/test';
export const manageNewsUrl = adminUrl + '/news';
export const newsAssignmentUrl = manageNewsUrl + assignmentUrl;
export const newsStatusUrl = manageNewsUrl + statusUrl;
export const newsCreatedByUrl = manageNewsUrl + createdByUrl;
export const coverImageUrl = adminUrl + '/imageCover';
export const coverImageStatusListUrl = adminUrl + '/imageCover/status';
export const coverImageCreatedByListUrl = adminUrl + '/imageCover/createdby';
export const deleteImageUrl = adminUrl + '/imageCover/image';
export const manageDocumentUrl = adminUrl + '/document';
export const documentTypesUrl = manageDocumentUrl + typeUrl;
export const documentCreatedByUrl = manageDocumentUrl + createdByUrl;
export const documentAssignUrl = manageDocumentUrl + assignmentUrl;
export const documentStatusUrl = manageDocumentUrl + statusUrl;
export const getMultiDropDownRegionListUrl =
  baseUrl + '/getMultidropdown/Region';
export const externalLinkUrl = adminUrl + '/link';
export const externalLinkTypesUrl = externalLinkUrl + typeUrl;
export const externalLinkCreatedByUrl = externalLinkUrl + createdByUrl;
export const externalLinkAssignUrl = externalLinkUrl + assignmentUrl;
export const externalLinkStatusUrl = externalLinkUrl + statusUrl;
export const manageStaticContentUrl = adminUrl + '/static-content';
export const deleteStaticContentUrl = adminUrl + '/delete-static-content';
export const manageStaticContentStatusUrl = manageStaticContentUrl + statusUrl;
export const manageStaticContentCreatedByUrl =
  manageStaticContentUrl + '/createdBy';
export const manageStaticContentTypeListUrl =
  manageStaticContentUrl + '/contentTypeList';
export const manageStaticContentReferenceListUrl =
  manageStaticContentUrl + '/contentReferenceList';
export const brandUrl = adminUrl + '/brand';
export const brandStatusUrl = brandUrl + statusUrl;
export const messageUrl = adminUrl + '/message';
export const getMessageTypesUrl = messageUrl + '/getMessageTypes';
export const getDisplayTypesUrl = messageUrl + '/getDisplayTypes';
export const getRoleTagDataUrl = messageUrl + '/getRoleTagData';
export const getContentTagDataUrl = messageUrl + '/getContentTagData';
export const getCustomerTagDataUrl = messageUrl + '/getCustomerTagData';
export const getSalesTagDataUrl = messageUrl + '/getSalesTagData';
export const groupsUrl = adminUrl + '/group';
export const deleteGroupsUrl = adminUrl + '/deleteGroup';
export const groupsAccessLevelUrl = groupsUrl + '/accessLevel';
export const groupsTypesUrl = groupsUrl + '/type';
export const groupsStatusUrl = groupsUrl + statusUrl;
export const checkAvailabilityUrl = groupsUrl + '/checkAvailability';
export const groupAssignmentUrl = groupsUrl + assignmentUrl;
export const groupSoldToUrl = groupsUrl + '/soldTo';
export const newSeasonUrl = adminUrl + '/newSeason';
export const multidropdowndbUrl = newSeasonUrl + '/multidropdowndb';
export const newSeasonStatusUrl = newSeasonUrl + statusUrl;
export const seasonMultidropdowndbUrl = multidropdowndbUrl + '/Season';
export const distributionChannelUrl =
  baseUrl + '/multidropdowndb/DISTRBUTION_CHANNEL';
export const roleListUrl = adminUrl + '/role/common/types';
export const regionUrlForSeasonWorkbench = baseUrl + '/multidropdowndb/region';
export const createdbyMessageUrl = messageUrl + createdByUrl;
export const userUrl = adminUrl + '/user';
export const deleteUserUrl = adminUrl + '/deleteUser';
export const userStatusUrl = userUrl + statusUrl;
export const userRoleUrl = adminUrl + '/role/common/types';
export const userTypeUrl = userUrl + '/type';
export const uploadUserExcel = userUrl + '/bulk';
export const activateUser = adminUrl + '/activate-user';
export const downloadUserExcel = userUrl + '/downloadUserExcel';
export const userAvailabilityCheckUrl = userUrl + '/checkAvailability';
export const userAvailabilityCheckUpdateUrl =
  userUrl + '/checkEditAvailability';
export const userGetGroupByType = userUrl + '/group';
export const userGetRoleByGroupId = userUrl + '/role';
export const userGetBusinessEntityByGroupIdUrl = userUrl + '/businessEntity';
export const userGetContentByRoleIdUrl = userUrl + '/menu';
export const userAssignmentUrl = userUrl + assignmentUrl;
export const userGetSalesRepListUrl = userUrl + '/getAvailableSalesRepList';
export const expiredCartUrl = adminUrl + '/expiredCart';
export const expiredCartStatusUrl = expiredCartUrl + statusUrl;
export const expiredCartCustomerListUrl = expiredCartUrl + '/getCartCustomers';
export const expiredCartTypesUrl = expiredCartUrl + '/getCartTypes';
export const expiredCartContextTypeUrl = expiredCartUrl + typeUrl;
export const expiredCartSeasonListUrl = expiredCartUrl + '/seasonCodeList';
export const expiredCartCreatedByListUrl = expiredCartUrl + createdByUrl;
export const expiredCartDetailUrl = expiredCartUrl + '/getCartProductsDetail';
export const roleUrl = adminUrl + '/role';
export const roleAssignmentUrl = roleUrl + '/assignment';
export const roleTypeUrl = roleUrl + '/type';
export const roleStatusUrl = roleUrl + statusUrl;
export const roleAccessLevelUrl = roleUrl + '/accessLevel';
export const roleNameCheckUrl = roleUrl + '/checkAvailability';
export const roleContentListUrl = roleUrl + '/contentGroups';
export const menuUrl = adminUrl + '/menu';
export const menuTypeUrl = menuUrl + '/type';
export const parentMenuUrl = menuUrl + '/parent';
export const statusMenuUrl = menuUrl + '/status';
export const roleMenuAssignmentListUrl = roleUrl + '/menu';
export const menuListUrl = menuUrl + '/user?typeId=3';
export const menuSequenceUrl = menuUrl + '/sequence';
export const menuSecurityUrl = menuUrl + '/url?typeId=3';
export const globalLinesheetUrl = adminUrl + '/globalLinesheet';

export const checkUniqueLineSheetNameUrl = baseUrl + '/linesheet/isUnique';
export const getActiveSeasonsUrl = adminUrl + '/getActiveSeasons';
export const getLineSheetProductsUrl = baseUrl + '/linesheet/getProducts';
export const updateProductsUrl = baseUrl + '/linesheet/updateProducts';
export const addProductUploadExcelUrl = adminUrl + '/addProductUploadExcel';
export const quickStyleEntryUrlrl = adminUrl + '/linesheet/quickStyleEntry';

export const downloadImagesAdminUrl = adminUrl + '/product/download/images/v2';
export const downloadUPCAdminUrl = adminUrl + '/product/download/upc/v2';
export const exportOrderFormAdminUrl =
  adminUrl + '/product/download/orderform/v2';
export const downloadPdfAdminUrl = adminUrl + '/downloadPdf/v2';
export const deleteCartProductsUrl = baseUrl + '/deleteCartProducts';
export const getCollectionsUrl = adminUrl + '/collections';
export const getCollectionsInfoUrl = adminUrl + '/collection/products';
export const keywordSuggestionUrl = baseUrl + '/product/typeAhead';
export const addToCartUrl = adminUrl + '/productlist/addToCart';
export const getLinesheetAvailableInternalUsersUrl =
  baseUrl + '/linesheet/getAvailableInternalUser';
export const getAvailableCustomerListUrl =
  adminUrl + '/getAvailableCustomerList';

export const getSelectedInternalUserUrl = baseUrl + '/getSelectedInternalUser';
export const getSelectedExternalUserUrl = baseUrl + '/getSelectedExternalUser';
export const getAvailableUserListUrl =
  baseUrl + '/linesheet/getAvailableUserList';
export const getLinesheetShareUrl = baseUrl + '/linesheet/share';
export const deleteLineSheetUrl = baseUrl + '/linesheet/delete';
export const getSearchedCustomersUrl = baseUrl + '/customer/search';
export const addToCartStyleQtyUrl = adminUrl + '/productdetail/addToCart';
export const getStyleDetailUrl = adminUrl + '/product/getStyleDetail';
export const updateLinesheetBanner = adminUrl + '/globalLinesheet/image';

export const getMaintenanceStatusUrl = baseUrl + '/maintenanceCheck';

// Proposals
export const updateProposalStatus = (proposalId: number) =>
  `${baseUrl}/proposals/${proposalId}/status`;
export const getProposalsUrl = `${baseUrl}/proposals`;
export const deleteProposalUrl = `${baseUrl}/proposals`;

// Member Users
export const getMembersUrl = `${baseUrl}/members`;
// Version History
export const getVersionHistoryUrl = `${baseUrl}/proposals/version-history`;

// Global Configuration
export const getGlobalConfigUrl = `${baseUrl}/globalConfigurations`;

// Sales Office
export const getRegionUrl = (wizardType: string) =>
  `${baseUrl}/proposals/masterDataList/REGION_TYPES?wizardTypeCode=${
    wizardType == 'events' ? eventWizard : VPS
  }`;
export const getSeasonTypeUrl = (wizardType: string) =>
  `${baseUrl}/proposals/masterDataList/SEASON_TYPES?wizardTypeCode=${
    wizardType == 'events' ? eventWizard : VPS
  }`;
export const getDeliveryTypeUrl = (wizardType: string) =>
  `${baseUrl}/proposals/masterDataList/DELIVERY_DATE_TYPES?wizardTypeCode=${
    wizardType == 'events' ? eventWizard : VPS
  }`;
//Margin Types
export const getMarginTypeUrl = (wizardType: string) =>
  `${baseUrl}/proposals/masterDataList/MARGIN_TYPES?wizardTypeCode=${
    wizardType == 'events' ? eventWizard : VPS
  }`;
//Proposal Types
export const getProposalTypesUrl = (wizardtype: string) =>
  `${baseUrl}/proposals/masterDataList/PROPOSAL_TYPE?wizardTypeCode=${
    wizardtype == 'events' ? eventWizard : VPS
  }`;
//Proposal Types based on event
export const getProposalTypesUrlBasedOnEvent = (wizardtype: string) =>
  `${baseUrl}/proposals/masterDataList/PROPOSAL_TYPE?wizardTypeCode=${wizardtype}`;

//Instruction Master Data List
export const getEventsInstructionTypesUrl =
  `${baseUrl}/proposals/masterDataList/INSTRUCTION_TYPES?wizardTypeCode=` +
  eventWizard;
export const getVPSInstructionTypesUrl =
  `${baseUrl}/proposals/masterDataList/INSTRUCTION_TYPES?wizardTypeCode=` + VPS;
//Account Number
export const getAccountNumbersUrl = `${baseUrl}/proposals/tradePartners/current`;
export const getAccountNumbersSearchQueryUrl = (query?: string) =>
  `${baseUrl}/proposals/tradePartners/current${
    query !== null && query !== undefined ? '?search=' + query : ''
  }`;

export const getTradePartnersUrl = `${baseUrl}/proposals/tradePartners`;
// Sales Reps
export const getSalesRepsUrl = `${baseUrl}/proposals/tradePartners/current/brand/current/salesrep`;

export const getCategoriesByMargin = (proposalId: number) =>
  `${baseUrl}/proposals/${proposalId}/categories`;

export const getShippingOptionsUrl = (wizardType: string) =>
  `${baseUrl}/proposals/masterDataList/SHIPPING_TYPES?wizardTypeCode=${
    wizardType == 'events' ? eventWizard : VPS
  }`;

export const saveProposalUrl = `${baseUrl}/proposals`;
export const getBrandsUrl = (id: number) => `${baseUrl}/proposals/brands/${id}`;
export const getProposalDetailsUrl = (id: number) =>
  `${baseUrl}/proposals/${id}`;
export const getTradePartnerUrl = (region: string) =>
  `${baseUrl}/proposals/tradePartners/${region}`;

export const getExperienceTypeUrl = (proposalTypeCode: string) =>
  `${baseUrl}/proposals/experienceTypes/proposalType/${proposalTypeCode}`;
export const getRepresentativesListUrl = (
  tradePartner: string,
  brand: string
) =>
  `${baseUrl}/proposals/tradePartners/${tradePartner}/brand/${brand}/salesrep`;

export const getProductListUrl = (proposalId: string, packageId: string) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products/search`;

export const getCollectionProductsUrl = (
  proposalId: string,
  collectionId: string
) => `${baseUrl}/proposals/${proposalId}/products/collections/${collectionId}`;

export const getProductDetailsUrl = (
  proposalId: string,
  packageId: string,
  style: string,
  productId: string,
  isFromOptions: string,
  styleMappingId: string | null
) => {
  if (styleMappingId == null || styleMappingId.length == 0) {
    return `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products/details?styleName=${style}&materialNumber=${productId}`;
  }
  return `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products/details?styleName=${style}&materialNumber=${productId}&isFromOptions=${isFromOptions}&styleMappingId=${styleMappingId}`;
};

export const getProductDetailsVPSUrl = (
  proposalId: string,
  style: string,
  productId: string
) => {
  return `${baseUrl}/proposals/${proposalId}/virtual-proshop/products/details?styleName=${style}&materialNumber=${productId}`;
};

export const getProposalPackagesUrl = (
  proposalId: string,
  experienceTypeId: string
) =>
  `${baseUrl}/proposals/${proposalId}/experienceType/${experienceTypeId}/packages`;

export const getPackageProductsUrl = (proposalId: string, packageId: string) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products`;

export const addProductsToPackageUrl = (
  proposalId: string,
  packageId: string
) => `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products`;

export const removeProductFromPackage = `${baseUrl}/products`;

export const getProductCollectionListUrl = (proposalId: string) =>
  `${baseUrl}/proposals/${proposalId}/products/collections`;

export const uploadImages = (proposalId, imageType) =>
  `${baseUrl}/proposals/${proposalId}/${imageType}`;
export const deleteHomePageImage = (proposalId, imageId, imageName) =>
  `${baseUrl}/proposals/${proposalId}/homePageImage?id=${imageId}&homePageImageName=${imageName}`;
export const deleteImage = (proposalId, imageType) =>
  `${baseUrl}/proposals/${proposalId}/${imageType}`;
export const sequenceProducts = (packageId, proposalId) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products`;
export const sequencePackages = (proposalId) =>
  `${baseUrl}/proposals/${proposalId}/packages`;

export const shareProposalUrl = (proposalId: string) =>
  `${baseUrl}/proposals/${proposalId}/share`;
export const copyProposalUrl = (proposalId: string) =>
  `${baseUrl}/proposals/${proposalId}/copy`;

export const createPackageUrl = () => `${baseUrl}/proposals/packages`;

export const updatePackageUrl = (packageId: string) =>
  `${baseUrl}/proposals/packages/${packageId}`;

export const deletePackageUrl = (packageId: string) =>
  `${baseUrl}/proposals/packages/${packageId}`;

export const productHierarchyUrl = (proposalId: string) =>
  `${baseUrl}/proposals/${proposalId}/products/navigation`;

export const staticContentApi = (contentReferenceName: string) =>
  `${baseUrl}/proposals/contentReferenceName/${contentReferenceName}`;

export const orderHeaderAPI = (proposalId: number) =>
  `${baseUrl}/proposals/${proposalId}/header`;

export const orderListAPI = (proposalId: number) =>
  `${baseUrl}/proposals/${proposalId}/micrositeOrders`;

export const orderDetailAPI = (proposalId: number, orderId: number) =>
  `${baseUrl}/proposals/${proposalId}/micrositeOrders/${orderId}`;
export const storeopeningAlertUrl = (proposalId: string) =>
  `${baseUrl}/proposals/${proposalId}/storeOpening`;

export const getConfigKeyValueUrl = baseUrl + '/getConfiguration';
export const getProductCustomisationInfo =
  baseUrl + '/getProductCustomisationInfo';

export const getProductOptionsUrl = (
  proposalId: string,
  packageId: string,
  styleMappingId: string
) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products/${styleMappingId}/options`;

export const addProductAsOptionUrl = (
  proposalId: string,
  packageId: string,
  styleMappingId: string
) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/products/${styleMappingId}/options`;

export const updateProductOptionsSequencesUrl = (
  proposalId: string,
  packageId: string,
  styleMappingId: string
) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/style/${styleMappingId}/options/sequence`;

export const updateProductOptionsSpecialPriceUrl = (
  proposalId: string,
  packageId: string,
  styleMappingId: string
) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/style/${styleMappingId}/options/special-price`;

export const deleteProductOptionUrl = (
  proposalId: string,
  packageId: string,
  styleMappingId: string,
  style: string
) =>
  `${baseUrl}/proposals/${proposalId}/packages/${packageId}/style/${style}/styleMappingId/${styleMappingId}/options`;

export const getConsolidateOrderTypeApi = (wizardType: string) =>
  `${baseUrl}/proposals/masterDataList/ORDER_CONSOLIDATE_TYPES?wizardTypeCode=${
    wizardType == 'events' ? eventWizard : VPS
  }`;

export const virtualProShopCollectionSelection = (proposalId: number) =>
  `${baseUrl}/proposals/${proposalId}/collections`;

export const proposalTypeResetApi = (proposalId: number, type: string) =>
  `${baseUrl}/proposals/${proposalId}/type/${type}/reset`;

export const createProposalPDFApi = (proposalId: number, packageId: string) =>
  `${baseUrl}/proposals/${proposalId}/package/${packageId}/pdf`;

export const getEventTypesUrl = () =>
  `${baseUrl}/proposals/masterDataList/WIZARD_TYPES?wizardTypeCode=`;

export const getEventSubTypesUrl = (eventTypeCode: string) =>
  `${baseUrl}/proposals/masterDataList/PROPOSAL_TYPE?wizardTypeCode=${eventTypeCode}`;
export const getReportById = (reportTypeCategory: string) =>
  `${baseUrl}/aps/report/${reportTypeCategory}`;

// Lead time config

export const getLeadTimeConfigUrl = `${baseUrl}/admin/custom-product-lead-time`;

export const saveLeadTimeConfigUrl = `${baseUrl}/admin/custom-product-lead-time/save`;

export const resetLeadTimeConfigUrl = (countryCode: string) => `${baseUrl}/admin/custom-product-lead-time/reset/${countryCode}`;

export const removeLeadTimeConfigUrl = `${baseUrl}/admin/custom-product-lead-time/remove`;
